import { render, staticRenderFns } from "./AddEmployeeToWorkShift.vue?vue&type=template&id=68030c95"
import script from "./AddEmployeeToWorkShift.vue?vue&type=script&lang=js"
export * from "./AddEmployeeToWorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports